<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="home-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-12 mb-50"></div>
              </div>

              <section id="ngx-datatable-kitchen-sink">
                <ngx-datatable
                  [messages]="{
                    emptyMessage: 'No se encontraron notificaciones'
                  }"
                  [rows]="notifications"
                  rowHeight="auto"
                  class="bootstrap core-bootstrap"
                  [limit]="10"
                  columnMode="force"
                  [headerHeight]="40"
                  [footerHeight]="50"
                  [scrollbarH]="false"
                >
                  <ngx-datatable-column
                    [width]="500"
                    name="Título"
                    prop="title"
                    [sortable]="false"
                  >
                    <ng-template
                      ngx-datatable-cell-template
                      let-value="value"
                      let-row="row"
                      let-rowIndex="rowIndex"
                    >
                      <b>
                        <i
                          *ngIf="!row.is_read"
                          class="text-primary fa-solid fa-circle"
                        ></i>
                        {{ row.title }}</b
                      >
                      <p>{{ row.message }}</p>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="Fecha" [sortable]="false" prop="created_at">
                    <ng-template
                      ngx-datatable-cell-template
                      let-value="value"
                      let-row="row"
                      [width]="20"
                      let-rowIndex="rowIndex"
                    >
                      {{ row.created_at | date : "dd-MM-yyyy HH:mm:ss" }}
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column
                    name="Acciones"
                    [width]="5"
                    [sortable]="false"
                  >
                    <ng-template
                      ngx-datatable-cell-template
                      let-value="value"
                      let-row="row"
                      let-rowIndex="rowIndex"
                    >
                      <div class="d-flex align-items-center">
                        <i
                          *ngIf="!row.is_read"
                          (click)="readNotification(row.id)"
                          class="action fa-solid fa-xmark"
                        ></i>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
